import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon, QrCodeIcon, KeyRoundIcon } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
import { StoreBadges } from './StoreBadges';
const methods = [{
  icon: Link2Icon,
  label: 'A link',
  detail: 'Tap it, pick a name, done.'
}, {
  icon: QrCodeIcon,
  label: 'A QR code',
  detail: 'Point a camera at the screen.'
}, {
  icon: KeyRoundIcon,
  label: 'A join code',
  detail: 'Type the reference in.'
}];
export function WaysToJoin() {
  return <section id="ways-to-join" className="relative overflow-hidden bg-kitty-yellow py-20 lg:py-28" data-id="element-345" data-mp="2al5ng0zy0j2c">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-346" data-mp="2fg1fv293d8fz">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-10" data-id="element-347" data-mp="2jipqnfhd8pfl">
          {/* Screens */}
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="order-2 lg:order-1 lg:col-span-6" data-id="element-348" data-mp="l5679zxwptd7">
            <div className="relative mx-auto w-full max-w-[280px] sm:max-w-[520px]" data-id="element-349" data-mp="1lmrb32s370jk">
              {/* The QR share screen, tucked behind */}
              <PhoneFrame screen={screens.shareQr} decorative className="absolute right-0 top-[14%] hidden w-[44%] rotate-[8deg] sm:block" data-id="element-350" data-mp="1br7lsz81303s" />
              {/* The browser join, front and large */}
              <div className="relative z-10 w-full sm:w-[62%]" data-id="element-351" data-mp="24etycwz8hf2s">
                <PhoneFrame screen={screens.webJoin} shadow="xl" data-id="element-352" data-mp="1zg0jb04atg0i" />
              </div>
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="order-1 lg:order-2 lg:col-span-6" data-id="element-353" data-mp="1ug4cyu84pchs">
            <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-dark/60" data-id="element-354" data-mp="3787honc9mofa">
              The bit other apps get wrong
            </p>
            <h2 className="mb-5 text-4xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-5xl lg:text-6xl" data-id="element-355" data-mp="2xa1hca63xqcj">
              No app?
              <br data-id="element-356" data-mp="326rx0we02jxf" />
              No problem.
            </h2>
            <p className="mb-4 max-w-md text-lg font-medium leading-relaxed text-kitty-dark lg:text-xl" data-id="element-357" data-mp="2njgkos9zuvw9">
              Send a link, QR code or join code. Friends can join the kitty from
              their browser without downloading KittyPot.
            </p>
            <p className="mb-9 max-w-md text-lg font-bold text-kitty-dark" data-id="element-358" data-mp="2eh7docdxpknm">
              They choose their name and they're in.
            </p>

            <ul className="mb-9 grid gap-3 sm:grid-cols-3" data-id="element-359" data-mp="24lvvfk3bhvb4">
              {methods.map(method => <li key={method.label} className="rounded-2xl bg-white/70 p-4 backdrop-blur-sm" data-id="element-360" data-mp="29kgwflqe8j0m">
                  <method.icon className="mb-2.5 h-5 w-5 text-kitty-dark" aria-hidden="true" data-id="element-361" data-mp="1pxm4i1i1sfb3" />
                  <p className="font-extrabold text-kitty-dark" data-id="element-362" data-mp="1lx26kvpnh7nw">
                    {method.label}
                  </p>
                  <p className="mt-0.5 text-sm text-kitty-dark" data-id="element-363" data-mp="1zxcxfyqymm92">
                    {method.detail}
                  </p>
                </li>)}
            </ul>

            <div className="rounded-2xl bg-kitty-dark p-6" data-id="element-364" data-mp="28x01ksb2q65t">
              <p className="mb-4 text-base font-bold text-white" data-id="element-365" data-mp="28vgi6su4fezt">
                Organising it? Get the app for the full picture, including My
                Balance across all your kitties.
              </p>
              <StoreBadges tone="dark" data-id="element-366" data-mp="2ioxf45pk1a7p" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}